import React from 'react';
import Accordion from './accordion';
import Checkbox from './checkbox';
import { formatNumber } from '../helpers/CommonHelpers';
import he from 'he';

export default function FilterSection({ itemArray, selectedArray, title, onChange, defaultIsOpen = false }) {
  const handleCheckboxChange = (id, checked) => {
    if (onChange) onChange(id, checked);
  }

  return <Accordion title={title} variant="bottomBorder" defaultIsOpen={defaultIsOpen}>
  <ul>
    {itemArray.map(item => {
      return (
        <li key={`${title}_${item.id}`}>
          <Checkbox
            id={`${title}_${item.id}`}
            value={`${item.id}`}
            label={`${he.decode(item.name)}`}
            checked={selectedArray.includes(item.id) || false}
            onChange={() => handleCheckboxChange(item.id)}
            className=""
            formatechild={item.count > 0 ? formatNumber(item.count) : item.count}
            disabled={item.count == 0 ? true : false}
          />
        </li>
      )
    }
    )}
  </ul>
</Accordion>
}